/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhContact.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhContact-view">
        <Helmet>
          <title>聯絡我們 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhContact-first">
          <div className="ZhContact-heading">聯絡我們</div>

          <div className="ZhContact-centerContainer">
            <a className="ZhContact-option" href="mailto:help@check.plus">
              <div className="ZhContact-pic">
                <div className="ZhContact-email"></div>
              </div>
              <div className="ZhContact-name">
                <strong>電子郵件</strong>
              </div>
            </a>

            <a
              className="ZhContact-option"
              href="https://wa.me/message/WJ4IE7JQ2FTMP1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="ZhContact-pic">
                <div className="ZhContact-qr"></div>
              </div>
              <div className="ZhContact-name">
                <strong>WhatsApp</strong>
              </div>
            </a>
          </div>
        </div>

        <div className="ZhContact-footer">
          <div className="ZhContact-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhContact-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhContact-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhContact-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhContact-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhContact-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhContact-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhContact;
